import { useCallback } from "react";
import { performLogout } from "@/src/auth/services/logout.service";

export function useLogout() {
	return useCallback(() => performLogout(), []);
}
